import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoadingSpinnerService } from '../../../../services/loading-spinner/loading-spinner.service';
import { DispatcherService } from '../../../../services/dispatcher.service';
import { ThemeService } from '../../../../services/theme.service';
import { ExternalTicketService } from '../../services/external-ticket.service';

@Component({
  selector: 'app-external-ticket',
  templateUrl: './external-ticket.component.html',
  styleUrls: ['./external-ticket.component.css']
})
export class ExternalTicketComponent implements OnInit, OnDestroy {

  private _backButtonVisible: boolean;
  private _abortButtonVisible: boolean;
  private _activatedRouteParamsSubscription: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private loadingSpinnerService: LoadingSpinnerService,
    private dispatcherService: DispatcherService,
    private themeService: ThemeService,
    private externalTicketService: ExternalTicketService,
  ) {
  }

  ngOnInit(): void {
    this.dispatcherService.pageHeaderSet();
    this._backButtonVisible = this.dispatcherService.isBackButtonVisible;
    this.dispatcherService.isBackButtonVisible = false;
    this._abortButtonVisible = this.dispatcherService.isAbortButtonVisible;
    this.dispatcherService.isAbortButtonVisible = false;

    this.loadingSpinnerService.show();
    this.themeService.updateCustomCss();

    this._activatedRouteParamsSubscription = this.activatedRoute.queryParams.subscribe(params => {
      this.externalTicketService.initialize(params);
      this.externalTicketService.activate();
      this.loadingSpinnerService.hide();
    });
  }

  ngOnDestroy(): void {
    this.dispatcherService.pageHeaderSet();
    this.dispatcherService.isBackButtonVisible = this._backButtonVisible;
    this.dispatcherService.isAbortButtonVisible = this._abortButtonVisible;

    if (this._activatedRouteParamsSubscription) {
      this._activatedRouteParamsSubscription.unsubscribe();
      this._activatedRouteParamsSubscription = null;
    }
  }
}
